import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iconify from '../../../Iconify';
import { useCallback } from 'react';
import '../../../../css/roles/successfulAddRoleDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddRole_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddRole_action_icon' />
        <Typography className='SuccessfulAddRole_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfullAddArticleItemDialog = ({
    openSuccessfulAddArticleItem,
    setOpenSuccessfulAddArticleItem,
    setOpenAddArticleItem,
    listLabel,
    addAnotherLabel = 'Ajouter un autre article',
}) => {

    const { t } = useTranslation();

    const handleOpenAdd = useCallback(() => {
        setOpenSuccessfulAddArticleItem(false);
        setOpenAddArticleItem(true);
    }, [setOpenAddArticleItem, setOpenSuccessfulAddArticleItem]);

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddArticleItem(false);
    }, [setOpenSuccessfulAddArticleItem]);

    return (
        <Dialog open={openSuccessfulAddArticleItem} onClose={handleClose} classes={{ paper: 'SuccessfulAddRole_dialog' }}>
            <IconButton onClick={handleClose} className='SuccessfulAddRole_icon_button'>
                <Iconify icon={"material-symbols:close"} className='SuccessfulAddRole_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddRole_dialog_content' >
                <Iconify icon={"lets-icons:check-ring-light"} className='SuccessfulAddRole_check_icon' />
                <Typography className='SuccessfulAddRole_message'>{t('AddMachine_validation_message')}</Typography>
                <Box className='SuccessfulAddRole_action_container'>
                    <ActionBox
                        icon={"material-symbols-light:cards-outline"}
                        text={listLabel || t("List des dossiers d'articles")}
                        onClick={handleClose}
                    />
                    <ActionBox
                        icon={"material-symbols-light:add"}
                        text={addAnotherLabel}
                        onClick={handleOpenAdd}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};